module.exports = __webpack_public_path__ + "img/Hickory.a4e5e74f.png";